import React, { useState } from 'react';
import './App.css';

function App() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/sql') {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
      alert('Please select a valid SQL file');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedFile) {
      alert('Please select a file first');
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);

      const response = await fetch('https://wowcrudapi.hakunamatatatech.io/upload', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // Create a blob from the response
        const blob = await response.blob();
        
        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'treeplantation.zip';
        
        // Trigger the download
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        // alert('File downloaded successfully!');
      } else {
        throw new Error('Upload failed');
      }
    } catch (error) {
      alert('Error uploading file: ' + error.message);
    } finally {
      setUploading(false);
      setSelectedFile(null);
    }
  };

  return (
    <div className="container">
      <div className="upload">
     
      <form onSubmit={handleSubmit} className="upload-form">
        <h1>SQL File Upload</h1>
        <div className="file-input">
          <input
            type="file"
            accept=".sql"
            onChange={handleFileSelect}
            disabled={uploading}
          />
          {selectedFile && (
            <p className="selected-file">Selected: {selectedFile.name}</p>
          )}
        </div>
        <button
          type="submit"
          disabled={!selectedFile || uploading}
          className="submit-button"
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
      </form>
      </div>
     
    </div>
  );
}

export default App;
